module.exports = __webpack_public_path__ + "static/media/tags.51b65d3f.svg";